import {
  compose,
  withHandlers,
  lifecycle,
  branch,
} from 'recompose';
import { GALLERY_NODE_ID } from './withPdpPreview';

const PREVIEW_NODE_ID = 'pb-preview-node';

const isPreviewNodeNotExist = () => !document.querySelector(`#${PREVIEW_NODE_ID}`);

// eslint-disable-next-line
export const withCreatePreviewNodeOnMount = compose(
  withHandlers({
    createPreviewNode: ({ setOpen, t }) => () => {
      const createA = document.createElement('a');
      const searchIcon = document.createElement('i');
      const createAText = document.createTextNode(t('footer.issuupreview_preview', 'PREVIEW'));
      const textWrapper = document.createElement('span');
      searchIcon.setAttribute('class', 'fa fa-search-plus');
      textWrapper.setAttribute('class', 'ml-2 ProximaNova-Bold');
      textWrapper.appendChild(createAText);
      createA.onclick = () => { setOpen(true); };
      createA.setAttribute('href', 'javascript:void(0);');
      createA.setAttribute('class', 'btn btn-link text-center my-2');
      createA.setAttribute('style', 'font-size: 18px');
      createA.setAttribute('id', PREVIEW_NODE_ID);
      createA.appendChild(searchIcon);
      createA.appendChild(textWrapper);
      const element = document.querySelector('.product-view-wrapper');
      element.after(createA);
    }
  }),
  branch(
    isPreviewNodeNotExist,
    lifecycle({
      componentDidMount() {
        this.props.createPreviewNode();
      }
    })
  ),
);



// WEBPACK FOOTER //
// ./src/IssuuPreview/withCreatePreviewNode.js